export default __webpack_public_path__ + "static/char-s-62-zh-Hant-f665c9600d92c71ea6aa182438dfaaf1.png";